module.exports = __webpack_public_path__ + "img/rightthigh-ecto-mesomorph-male.ca248973.svg";